export default __webpack_public_path__ + "static/geovelo-02faab9bb8f77a9fe5b6ac75e5b20a9b.png";